function calculateRate (t, i, s) {
    let n = 0.05;
    if (t === 1) return i / -s - 1;
    for (let e = 0; e < 1e3; e++) {
        var r = s * Math.pow(1 + n, t) + i * ((Math.pow(1 + n, t) - 1) / n),
            a = s * t * Math.pow(1 + n, t - 1) + i * ((Math.pow(1 + n, t) - 1) / n) + i * t * Math.pow(1 + n, t - 1);
        if (Math.abs(a) < 1e-10) n += 1e-4;
        else {
            r = n - r / a;
            if (Math.abs(r - n) < 1e-10) return r;
            n = r;
        }
    }
    return i / -s / t;
  }
  
  function pmt(i, n, p) {
    return (i * p * Math.pow(1 + i, n)) / (1 - Math.pow(1 + i, n))
  }
  
  function irr(values, guess) {
    // Credits: algorithm inspired by Apache OpenOffice
  
    // Calculates the resulting amount
    var irrResult = function (values, dates, rate) {
      var r = rate + 1
      var result = values[0]
      for (var i = 1; i < values.length; i++) {
        result += values[i] / Math.pow(r, (dates[i] - dates[0]) / 365)
      }
      return result
    }
  
    // Calculates the first derivation
    var irrResultDeriv = function (values, dates, rate) {
      var r = rate + 1
      var result = 0
      for (var i = 1; i < values.length; i++) {
        var frac = (dates[i] - dates[0]) / 365
        result -= (frac * values[i]) / Math.pow(r, frac + 1)
      }
      return result
    }
  
    // Initialize dates and check that values contains at least one positive value and one negative value
    var dates = []
    var positive = false
    var negative = false
    for (var i = 0; i < values.length; i++) {
      dates[i] = i === 0 ? 0 : dates[i - 1] + 365
      if (values[i] > 0) positive = true
      if (values[i] < 0) negative = true
    }
  
    // Return error if values does not contain at least one positive value and one negative value
    if (!positive || !negative) return "#NUM!"
  
    // Initialize guess and resultRate
    var guessResult = typeof guess === "undefined" ? 0.1 : guess
    var resultRate = guessResult
  
    // Set maximum epsilon for end of iteration
    var epsMax = 1e-10
  
    // Set maximum number of iterations
    var iterMax = 180
  
    // Implement Newton's method
    var newRate, epsRate, resultValue
    var iteration = 0
    var contLoop = true
    do {
      resultValue = irrResult(values, dates, resultRate)
      newRate = resultRate - resultValue / irrResultDeriv(values, dates, resultRate)
      epsRate = Math.abs(newRate - resultRate)
      resultRate = newRate
      contLoop = epsRate > epsMax && Math.abs(resultValue) > epsMax
    } while (contLoop && ++iteration < iterMax)
  
    if (contLoop) return "#NUM!"
  
    // Return internal rate of return
    return resultRate
  }
  
  /**
   * İstenen tutar (TL) ve vade için TL cinsinden aylık ödeme tutarını hesaplar
   * (Kodlar, Direkt Kredi Hızlı Başvurudan alınmıştır. https://tfs.akbank.com/DefaultCollection/SMPU/_versionControl?path=%24%2FSMPU%2FDigitalProduct%2FAkbank.DirektKredi.Lead%2FDEV%2FSource%2FAkbank.DirektKredi.Lead.UI%2Fassets%2Fjs%2Fcore.js)
   * @param {number} amount Kredi tutarı
   * @param {number} vade Vade
   * @param {object} productInfo Kredi ürününe ait bilgiler (faiz listesi, min/max vade, min/max tutar, masraf b. )
   */
  export function calculateMonthlyPayment(amount, vade, productInfo, exspertizAndRehinAmount, isCommercial = false) {
    if (amount < productInfo.iMinTutar || amount > productInfo.iMaxTutar) {
      return null
    }
    // if (vade < productInfo.minVadeTl || vade > productInfo.maxVadeTl) {
    //   return null
    // }
    let productDetail = {
      minVade: productInfo.minVadeTl,
      maxVade: productInfo.maxVadeTl,
      minTutar: productInfo.minTutar,
      maxTutar: productInfo.maxTutar,
      masraf: productInfo.masraf,
      kkdf: productInfo.fonOran * 1.0,
      bsmv: productInfo.vergiOran * 1.0,
      faizAdet: productInfo.faizAdet,
      faizler: productInfo.faizArrayListesi
    }
  
    const istenenVade = vade
    const istenenTutar = amount
  
    var urunMasraf = productDetail.masraf
    var urunMaxTutar = productDetail.maxTutar
    var faizOrani = 0.0
  
    var hesaplananMasraf = (urunMasraf / urunMaxTutar) * istenenTutar
    var vadeFaizArray = []
  
    if (isCommercial) {
      for (var i = 0; i < productDetail.faizler.length; i++) {
        if (
          istenenVade >= Math.ceil(productDetail.faizler[i].minVade / 30) &&
          istenenVade <= Math.floor(productDetail.faizler[i].maxVade / 30)
        ) {
          vadeFaizArray.push(productDetail.faizler[i])
        }
      }
    } else {
      for (var i = 0; i < productDetail.faizler.length; i++) {
        if (
          istenenVade >= productDetail.faizler[i].minVade &&
          istenenVade <= productDetail.faizler[i].maxVade
        ) {
          vadeFaizArray.push(productDetail.faizler[i])
        }
      }
    }
  
    for (var y = 0; y < vadeFaizArray.length; y++) {
      if (
        istenenTutar >= vadeFaizArray[y].minKrediTutari &&
        istenenTutar <= vadeFaizArray[y].maxKrediTutari
      ) {
        faizOrani = vadeFaizArray[y].tlOran.replace(/,/g, ".")
      }
    }
  
    // Beklenen Örnek Değerler:
    // faizOrani: 2.05 | KKDF: 15 | BSMV: 10
    // ir = (Ürünün Faiz Oranı / 100) + Ürünün Faiz Oranının KKDF + BSMV yüzdesi kadar fazlası
    var ir = (faizOrani / 100.0) * (1.0 + (productDetail.kkdf + productDetail.bsmv) / 100.0)
  
    var aylikOdeme = pmt(ir, istenenVade, -istenenTutar)
  
    var masrafsizTutar = hesaplananMasraf - istenenTutar
    masrafsizTutar = masrafsizTutar + exspertizAndRehinAmount;
    var r = calculateRate(vade, aylikOdeme, masrafsizTutar);
    var vadeCounter = istenenVade
    var taksitArray = []
    while (vadeCounter--) {
      taksitArray[vadeCounter] = aylikOdeme
    }
    taksitArray.unshift(masrafsizTutar)
    var calculatedIRR = irr(taksitArray)
    //var monthIRR = calculatedIRR * 100
    var efektifYillikFaizOrani = (Math.pow(1 + r, 12) - 1) * 100
  
    const faizOraniFormated = Number(faizOrani).toFixed(2)
    return {
      aylikOdeme: aylikOdeme,
      faizOrani: faizOraniFormated,
      yearlyInterestRate: efektifYillikFaizOrani,
      totalPaymentAmt: aylikOdeme * istenenVade
    }
  }
  